import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { money } from "@/components/am/shared";

function RefundRow({ r, reload }) {
  const [ref, setRef] = useState("");
  const done = async () => {
    if (!window.confirm(`Confirm you have refunded ${money(r.amount)} to ${r.site_name}?`)) return;
    try { await api.post(`/admin/diy-refunds/${r.id}/mark-refunded`, { confirm: true, reference: ref }); toast.success("Refund recorded"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 border-t border-slate-800 pt-2 text-sm" data-testid={`diy-refund-${r.id}`}>
      <span className="flex-1 min-w-[180px]">{r.site_name} <span className="text-xs text-slate-500">{r.created_at?.slice(0, 10)}</span></span>
      <span className="font-mono">{money(r.amount)}</span>
      {r.status === "refund_due" ? <>
        <Input className="h-8 w-56" placeholder="Refund reference (UPI/bank/Razorpay ID)" value={ref} onChange={(e) => setRef(e.target.value)} data-testid={`diy-refund-ref-${r.id}`} />
        <Button size="sm" disabled={!ref.trim()} onClick={done} data-testid={`diy-refund-mark-${r.id}`}>Mark refunded</Button></>
        : <span className="text-xs text-emerald-600">Refunded · {r.reference}</span>}
    </div>
  );
}

export default function DiyRefundsAdmin() {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get("/admin/diy-refunds").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);
  const due = rows.filter((r) => r.status === "refund_due"), done = rows.filter((r) => r.status !== "refund_due");
  return (
    <div className="lx-card space-y-2 mt-4" data-testid="admin-diy-refunds">
      <div className="font-semibold">DIY website refunds due</div>
      <p className="text-xs text-slate-500">Created when a customer approves a smaller scope after paying more than the new price. Nothing is refunded automatically: pay it back yourself, then record the reference here.</p>
      {due.length === 0 ? <p className="text-sm text-slate-500" data-testid="diy-refunds-empty">No refunds due.</p> : due.map((r) => <RefundRow key={r.id} r={r} reload={load} />)}
      {done.length > 0 && <details data-testid="diy-refunds-completed"><summary className="cursor-pointer text-xs text-slate-500">Completed refunds ({done.length})</summary>{done.map((r) => <RefundRow key={r.id} r={r} reload={load} />)}</details>}
    </div>
  );
}
